module.exports = __webpack_public_path__ + "img/icon_menu-close-dark.e3be8b8c.svg";